module.exports = __webpack_public_path__ + "img/sign_260010873_1.6370a06e.png";